import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Box,
  Typography,
} from '@material-ui/core';

const UNITS = [
  { value: 'ft', label: 'ft (feet)' },
  { value: 'in', label: 'in (inches)' },
  { value: 'meters', label: 'm (meters)' },
];

export default function CalibrationDialog({ open, onConfirm, onCancel }) {
  const [distance, setDistance] = useState('');
  const [unit, setUnit] = useState('ft');
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setDistance('');
      setUnit('ft');
      setError('');
    }
  }, [open]);

  const handleConfirm = () => {
    const parsed = parseFloat(distance);
    if (!distance || isNaN(parsed) || parsed <= 0) {
      setError('Please enter a positive number.');
      return;
    }
    setError('');
    onConfirm(parsed, unit);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleConfirm();
    if (e.key === 'Escape') onCancel();
  };

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Set Scale</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
          How long is this line in real life?
        </Typography>
        <Box display="flex" style={{ gap: 12 }} alignItems="flex-start">
          <TextField
            label="Distance"
            type="number"
            value={distance}
            onChange={(e) => { setDistance(e.target.value); if (error) setError(''); }}
            onKeyDown={handleKeyDown}
            error={Boolean(error)}
            helperText={error || ' '}
            inputProps={{ min: 0, step: 'any' }}
            autoFocus
            style={{ flex: 1 }}
            size="small"
            variant="outlined"
          />
          <TextField
            select
            label="Unit"
            value={unit}
            onChange={(e) => setUnit(e.target.value)}
            size="small"
            style={{ width: 130 }}
            variant="outlined"
            helperText=" "
          >
            {UNITS.map((u) => (
              <MenuItem key={u.value} value={u.value}>
                {u.label}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
